import { Link } from "react-router";
import styles from "../dropdown.css.js";
import cx from "../../../../lib/cx.js";

/**
 * A component that renders a link within a dropdown menu and performs specific actions when clicked.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.onClick - A callback function to be called when the link is clicked.
 * @param {Function} props.close - A function to close the dropdown.
 * @param {string} props.linkHost - (Optional) The base URL to be prefixed to the 'to' prop.
 * @param {string} props.to - The target URL of the link.
 * @param {React.ReactNode} props.children - The content to display inside the link.
 * @param {boolean} [props.isLast=false] - Flag indicating if this link is the last item in the dropdown.
 *
 * @return {JSX.Element} A React component that renders a link with the given properties.
 */
export function DropdownLink({
  onClick,
  close,
  linkHost,
  to,
  target,
  children,
  isLast = false,
}) {
  const handleClick = () => {
    if (onClick) onClick();
    close();
  };

  return (
    <Link
      to={linkHost ? `${linkHost}${to}` : to}
      onClick={handleClick}
      className={cx(styles.dropdownLink, isLast ? styles.lastDropdownLink : "")}
      target={target}
    >
      {children}
    </Link>
  );
}
